import ErrorBoundry from './ErrorBoundary';

export default ErrorBoundry;
